import { render } from "./NotificationSettingsView.vue?vue&type=template&id=696b91bb&ts=true"
import script from "./NotificationSettingsView.vue?vue&type=script&lang=ts"
export * from "./NotificationSettingsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__